import { get } from 'lodash';
export const getAppConfig = (state) => state.appConfig || {};
export const getSectionUrl = (state) => getAppConfig(state).sectionUrl;
export const getPostPageSectionUrl = (state) => getAppConfig(state).postPageSectionUrl;
export const getFeedSectionUrl = (state) => getAppConfig(state).feedSectionUrl;
export const getCategoryPath = (state) => getAppConfig(state).categoryPath;
export const getLogBiToConsole = (state) => getAppConfig(state).logBiToConsole;
export const getBundleName = (state) => getAppConfig(state).bundleName;
export const getIsDebugEnabled = (state) => getAppConfig(state).debugEnabled;
export const getImageHost = (state) => getAppConfig(state).imageHost;
export const getVideoHost = (state) => getAppConfig(state).videoHost;
export const getInstanceId = (state) => getAppConfig(state).instanceId;
export const getAmpBaseUrl = (state) => getAppConfig(state).ampBaseUrl;
export const getIsLinkifyEnabled = (state) => get(getAppConfig(state), 'editorConfig.enableLinkify', true);
export const getLinguistFlagsStaticsUrl = (state) => getAppConfig(state).linguistFlagsStaticsUrl;
const isBundleName = (state, name) => getBundleName(state) === name;
export const getIsAppBundle = (state) => isBundleName(state, 'blog');
export const getIsPostListWidgetBundle = (state) => isBundleName(state, 'post-list-widget');
export const getIsPostPageBundle = (state) => isBundleName(state, 'post-page');
//# sourceMappingURL=app-config-selectors.js.map